import _sfc_main from "./NotificationManager.vue2.js";
/* empty css                         */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const NotificationManager = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-59fc8983"]]);
export {
  NotificationManager as default
};
//# sourceMappingURL=NotificationManager.vue.js.map
